import {deserialize} from 'libs/cerialize';

export class AIQueryPropertyDto {
	@deserialize
	Id: number;

	@deserialize
	Name: string;
}